import PageHero from "@/components/PageHero";
import MineralCard from "@/components/MineralCard";
import Marquee from "@/components/Marquee";
import { Reveal, Overline } from "@/components/motion";
import { MINERALS, CONTACT, waLink } from "@/data/site";
import { MessageCircle } from "lucide-react";

export default function Products() {
  return (
    <main data-testid="products-page">
      <PageHero
        testid="products-hero"
        overline="Minerals & mine products"
        lines={["The Midlands,", "weighed and", "assayed."]}
        intro="Six core minerals, sourced directly from producers across Midlands Province and the Great Dyke. Every parcel is independently sampled and assayed before it is offered — what we quote is what ships."
      />

      <section data-testid="products-grid" className="mx-auto max-w-7xl px-6 pb-24 lg:px-10">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div className="md:col-span-2 lg:col-span-2 lg:row-span-1">
            <MineralCard mineral={MINERALS[0]} index={0} tall />
          </div>
          {MINERALS.slice(1).map((m, i) => (
            <MineralCard key={m.id} mineral={m} index={i + 1} />
          ))}
        </div>
      </section>

      <Marquee items={["Gold", "Chrome", "Lithium", "PGMs", "Nickel", "Iron Ore"]} />

      <section data-testid="products-cta" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
        <Reveal className="rounded-[2rem] border hairline-gold bg-navy-900/60 px-8 py-14 text-center lg:px-16">
          <Overline className="text-center">Buying or selling?</Overline>
          <h2 className="mx-auto mt-5 max-w-2xl font-serif text-3xl leading-tight tracking-tight text-slate-50 sm:text-4xl">
            Send us a grade and a tonnage — <em className="gold-text not-italic">we'll do the rest.</em>
          </h2>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <a
              href={waLink(CONTACT.phones[1].wa, "Hello Tuskers Grey Investments — I have a mineral enquiry.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="products-whatsapp-button"
              className="inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-navy-950 transition-all duration-300 hover:bg-gold-light"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp an enquiry
            </a>
            <a
              href={`mailto:${CONTACT.email}?subject=Mineral%20enquiry`}
              data-testid="products-email-button"
              className="inline-flex items-center gap-3 rounded-full border border-white/20 px-8 py-4 text-xs uppercase tracking-[0.25em] text-slate-200 transition-all duration-300 hover:border-gold/60 hover:text-gold"
            >
              {CONTACT.email}
            </a>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
